import axios from "axios";
import config from "../../../core/config/configureSettings";
import { constructServiceURL } from "../../../core/modules/common/tools/URLTools";

const postUser = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "postUser",
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceUrl);
};

const putSaveRecentUserReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putSaveRecentUserReport",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putSaveUserReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putSaveUserReport",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const deleteSavedUserReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteSavedUserReport",
    stub: config.useStubbedEndpoints,
    params: payload,
  });
  return axios.delete(serviceUrl, payload);
};

const putPinUserReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putPinUserReport",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorEdiMailboxSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorEdiMailboxSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserCountryUnlocodeSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserCountryUnlocodeSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorImpcProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorImpcProductSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorProductSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorNaImpcSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorNaImpcSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorNaSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorNaSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorImpcSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorImpcSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorNaImpcProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorNaImpcProductSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorNaProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorNaProductSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserMrdOperatorImpcSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserMrdOperatorImpcSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserOperatorNaCarrierProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserOperatorNaCarrierProductSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserCarrierSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserCarrierSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const putLastUserHandlerSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLastUserHandlerSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.put(serviceUrl, payload);
};

const getLastUserIMPCSelection = (postalOperatorType, direction) => {
  const serviceUrl =
    direction !== null
      ? constructServiceURL({
          endpoint: "getLastUserIMPCSelection",
          stub: config.useStubbedEndpoints,
          params: {
            postalOperatorType,
            direction,
          },
        })
      : constructServiceURL({
          endpoint: "getLastUserIMPCSelectionWithoutDirection",
          stub: config.useStubbedEndpoints,
          params: {
            postalOperatorType,
          },
        });

  return axios.get(serviceUrl);
};

const getLastUserMrdImpcSelection = (postalOperatorType) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getLastUserMrdImpcSelection",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
    },
  });

  return axios.get(serviceUrl);
};

const getLastUserCarrierSelection = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getLastUserCarrierSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getLastUserHandlerSelection = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getLastUserHandlerSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getLastUserMailboxSelection = (postalOperatorType, direction) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getLastUserMailboxSelection",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
      direction,
    },
  });

  return axios.get(serviceUrl);
};

const getLastUserUnlocodeSelection = (postalOperatorType, direction) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getLastUserUnlocodeSelection",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
      direction,
    },
  });

  return axios.get(serviceUrl);
};

const getLastUserProductSelection = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getLastUserProductSelection",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const putUserIMPCSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserIMPCSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedIMPCCodes);
};

const putUserOperatorSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserOperatorSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedIMPCCodes);
};

const putUserMrdImpcSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserMrdImpcSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedIMPCCodes);
};

const putUserCarrierSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserCarrierSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedCarriers);
};

const putUserHandlerSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserHandlerSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedHandlers);
};

const putUserMailboxSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserMailboxSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedEdiMailboxes);
};

const putUserUnlocodeSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserUnlocodeSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedUnlocodes);
};

const getUserIMPCSelections = (postalOperatorType) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserIMPCSelections",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
    },
  });

  return axios.get(serviceUrl);
};

const getUserOperatorSelections = (postalOperatorType) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserOperatorSelections",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
    },
  });

  return axios.get(serviceUrl);
};

const getUserMrdImpcSelections = (postalOperatorType) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserMrdImpcSelections",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
    },
  });

  return axios.get(serviceUrl);
};

const getUserCarrierSelections = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserCarrierSelections",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getUserHandlerSelections = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserHandlerSelections",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getUserMailboxSelections = (postalOperatorType) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserMailboxSelections",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
    },
  });

  return axios.get(serviceUrl);
};

const getUserUnlocodeSelections = (postalOperatorType) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserUnlocodeSelections",
    stub: config.useStubbedEndpoints,
    params: {
      postalOperatorType,
    },
  });

  return axios.get(serviceUrl);
};

const putUserProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putUserProductSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload.selectionName,
    },
  });

  return axios.put(serviceUrl, payload.selectedProducts);
};

const getUserProductSelections = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserProductSelections",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const deleteUserIMPCSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserIMPCSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserOperatorSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserOperatorSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserMrdImpcSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserMrdImpcSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserCarrierSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserCarrierSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserHandlerSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserHandlerSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserMailboxSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserMailboxSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserUnlocodeSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserUnlocodeSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const deleteUserProductSelection = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteUserProductSelection",
    stub: config.useStubbedEndpoints,
    params: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl, payload);
};

const getUserData = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getUserData",
    stub: config.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getAdminReportData = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getAdminReportData",
    stub: config.useStubbedEndpoints,
  });
  return axios.get(serviceUrl);
};

const getAdminReportCategoryData = () => {
  const serviceUrl = constructServiceURL({
    endpoint: "getAdminReportCategoryData",
    stub: config.useStubbedEndpoints,
  });
  return axios.get(serviceUrl);
};

const editAdminReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "editAdminReport",
    stub: config.useStubbedEndpoints,
    params: {
      reportCode: payload.reportCode,
    },
  });
  return axios.put(serviceUrl, payload.object);
};

const saveCategoryAdmin = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "saveCategoryAdmin",
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, payload.object);
};

const editCategoryAdmin = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "editCategoryAdmin",
    stub: config.useStubbedEndpoints,
    params: {
      categoryName: payload.categoryName,
    },
  });
  return axios.put(serviceUrl, payload.object);
};

const deleteCategoryAdmin = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "deleteCategoryAdmin",
    stub: config.useStubbedEndpoints,
    params: {
      categoryName: payload.categoryName,
    },
  });
  return axios.delete(serviceUrl);
};

const getScSets = (scSets, directionSet) => {
  const serviceUrl = constructServiceURL({
    endpoint: "getScSets",
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      scset: scSets,
      directionset: directionSet,
    },
  });

  return axios.get(serviceUrl);
};

const putDefaultLaunchPage = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: "putLaunchPage",
    stub: config.useStubbedEndpoints,
    params: {
      launchPage: payload.launchPage,
    },
  });

  return axios.put(serviceUrl, payload);
};
export default {
  postUser,
  getUserData,
  getAdminReportData,
  getAdminReportCategoryData,
  editAdminReport,
  saveCategoryAdmin,
  editCategoryAdmin,
  deleteCategoryAdmin,
  getUserIMPCSelections,
  getUserMrdImpcSelections,
  getUserCarrierSelections,
  getUserHandlerSelections,
  getUserMailboxSelections,
  getUserUnlocodeSelections,
  getUserProductSelections,
  getLastUserIMPCSelection,
  getLastUserMrdImpcSelection,
  getLastUserCarrierSelection,
  getLastUserHandlerSelection,
  getLastUserMailboxSelection,
  getLastUserUnlocodeSelection,
  getLastUserProductSelection,
  putSaveRecentUserReport,
  putSaveUserReport,
  deleteSavedUserReport,
  putPinUserReport,
  putUserIMPCSelection,
  putUserMrdImpcSelection,
  putUserCarrierSelection,
  putUserHandlerSelection,
  putUserMailboxSelection,
  putUserUnlocodeSelection,
  putUserProductSelection,
  putLastUserSelection,
  putLastUserOperatorEdiMailboxSelection,
  putLastUserOperatorImpcProductSelection,
  putLastUserOperatorNaImpcSelection,
  putLastUserOperatorImpcSelection,
  putLastUserOperatorNaImpcProductSelection,
  putLastUserMrdOperatorImpcSelection,
  putLastUserOperatorNaCarrierProductSelection,
  putLastUserCarrierSelection,
  putLastUserHandlerSelection,
  putLastUserCountryUnlocodeSelection,
  deleteUserIMPCSelection,
  deleteUserMrdImpcSelection,
  deleteUserCarrierSelection,
  deleteUserHandlerSelection,
  deleteUserMailboxSelection,
  deleteUserProductSelection,
  deleteUserUnlocodeSelection,
  getScSets,
  putDefaultLaunchPage,
  putLastUserOperatorProductSelection,
  putLastUserOperatorNaSelection,
  putLastUserOperatorNaProductSelection,
  putLastUserOperatorSelection,
  getUserOperatorSelections,
  putUserOperatorSelection,
  deleteUserOperatorSelection,
};
